import axios from 'axios';

export default function generateHireAgreementCrud(toApiUrl) {
  const SUBMIT_FORM_URL = toApiUrl('/hire-agreement');
  const VALIDATE_FORM_URL = toApiUrl('/hire-agreement/validate');
  const SUCCESS_URL = toApiUrl('/hire-agreement/get-success');
  const CAPTCHA_URL = toApiUrl('/captcha');
  const LOCATION_ADDRESS_URL = (locationName) =>
   toApiUrl(`/locations/by-name/${encodeURIComponent(locationName)}`);

  function submitForm(payload) {
    return axios.post(SUBMIT_FORM_URL, payload);
  }


  function checkCaptcha(payload) {
    return axios.post(CAPTCHA_URL, payload);
  }

  function validateForm(payload) {
    return axios.get(VALIDATE_FORM_URL, { params: payload });
  }

  function getSuccess(payload) {
    return axios.get(SUCCESS_URL, { params: payload });
  }

  function getLocationAddress(locationName) {
    return axios.get(LOCATION_ADDRESS_URL(locationName));
  }

  return {
    submitForm,
    checkCaptcha,
    validateForm,
    getSuccess,
    getLocationAddress
  };
} 
